"use strict";

define([], function () {
    // This is replaced by compiler
    return __BUILD_VERSION__;
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/version.js
 ** module id = 64
 ** module chunks = 0
 **/